import styled from "styled-components";

export const TableCardStyle = styled.div`
  border: 1px solid ${(props) => props.theme.colorbluegreylight};
  box-shadow: 0px 7px 33px -2px rgba(28, 39, 49, 0.05);
  border-radius: 6px;
  width: 100%;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 10px;
  .lock {
    color: ${(props) => props.theme.primary};
  }
  .notes {
    color: ${(props) => props.theme.textcolordarkgrey};
  }
  .delete {
    color: ${(props) => props.theme.colordanger};
  }
`;
